import Vue from 'vue'

const documentWindowEventHandler = new Vue({
  data () {
    return {
      currentFolder: null,
      forceReload: false,
      folderLoadFinishedEvent: null
    }
  },
  created () {
    let self = this
    this.forceReload = false
    // this event gets fired when the user clicks over a folder
    window.addEventListener('folderChanged', e => {
      let folderId = e.detail.SelectedFolderId()
      if (folderId != null) {
        self.currentFolder = folderId
      }
      self.forceReload = !self.forceReload
    })
  }
})

export default documentWindowEventHandler



// WEBPACK FOOTER //
// ./src/api/documentWindowEventHandler.js